import React from 'react'

// images and icons
import ShareSmallIcon from 'assets/icons/share-black-menu.svg?component'
import UnsaveIcon from 'assets/icons/unsave-icon-12x16.svg?component'
import TrashIcon from 'assets/icons/trash-bin-18x18.svg?component'
// styles
import styles from './index.module.scss'

interface CollectionCardMenuPageProps {
  shareCollection: any
  unSave: any
  isOwn: boolean
  isFavorite: boolean
}

const CollectionCardMenuPage = ({
  unSave,
  shareCollection,
  isOwn,
  isFavorite = false,
}: CollectionCardMenuPageProps) => {
  return (
    <div className={styles.nftMenu}>
      <div
        className={`${styles.menuItem}`}
        onClick={() => {
          shareCollection()
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <ShareSmallIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>Share Collection</div>
            <div className={styles.itemDescription}>Share to socials or copy link</div>
          </div>
        </div>
      </div>
      {isOwn && (
        <div>
          <div className={styles.separator} />

          <div
            className={`${styles.menuLastItem}`}
            onClick={() => {
              unSave()
            }}
          >
            {isFavorite ? (
              <div className="flex gap-[15px] items-center">
                <div className={styles.itemIcon}>
                  <UnsaveIcon alt="" />
                </div>
                <div>
                  <div className={styles.itemTitle}>Unsave</div>
                  <div className={styles.itemDescription}>Remove from my favorites</div>
                </div>
              </div>
            ) : (
              <div className="flex gap-[15px] items-center">
                <div className={styles.itemIcon}>
                  <TrashIcon alt="" />
                </div>
                <div>
                  <div className={styles.itemTitle}>Delete Collection & Items</div>
                  <div className={styles.itemDescription}>Remove from marketplace</div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default CollectionCardMenuPage
